"use client";

import type { GroupBrandRule } from "@/lib/groupBrandDiscount";

// ─── Aturan diskon merek per level yang SEDANG DIPAKAI storefront ─────────────
// Diisi CustomerContext tiap kali profil pembeli dimuat (mig 7070). Cadangan
// KEDUA jalur yang mengunci harga di checkout (`loadBrandRulesForCheckout`,
// pola A5 promo): bila RPC aturan gagal dua kali, harga yang dikunci = harga
// yang baru saja dilihat pembeli — bukan angka keranjang localStorage yang bisa
// diedit siapa pun. Diikat ke id pelanggan supaya sesi akun lain di perangkat
// yang sama tak pernah memakainya (bughunt E9, data per akun).

let session: { customerId: string; groupId: string | null; rules: GroupBrandRule[] } | null = null;

/**
 * Ingat aturan yang sedang dipajang. `groupId` = level pembeli saat aturan itu
 * dimuat — dipakai `loadDisplayedBrandRules` supaya aturan level LAMA tak
 * dipajang ulang sesudah pembeli dipindah level.
 */
export function rememberSessionBrandRules(
  customerId: string,
  rules: readonly GroupBrandRule[],
  groupId: string | null = null
): void {
  session = { customerId, groupId, rules: [...rules] };
}

export function forgetSessionBrandRules(): void {
  session = null;
}

/** Aturan sesi milik pelanggan INI, atau `null` (tak ada / milik akun lain). */
export function sessionBrandRulesFor(customerId: string): GroupBrandRule[] | null {
  return session && session.customerId === customerId ? [...session.rules] : null;
}

/**
 * Aturan yang DIPAJANG CustomerContext untuk pelanggan & level ini (bughunt
 * D13-4). Sukses → aturan baru, diingat. Gagal (timeout saat resync ketika tab
 * kembali aktif, jaringan HP) → aturan resolusi SEBELUMNYA untuk pelanggan DAN
 * level yang sama, sehingga harga yang sudah benar di layar tidak berubah —
 * prinsip "kegagalan transien → JANGAN ubah state" di CustomerContext. Dulu
 * sesi dilupakan SEBELUM mengambil, jadi satu timeout membuang harga merek dari
 * layar sekaligus cadangan checkout-nya.
 *
 * `null` = tak ada aturan yang bisa dipakai (gagal pada muatan pertama, atau
 * level sudah berganti): pemanggil memajang grup tanpa peta aturan, seperti
 * sebelumnya. Tak pernah melempar — kegagalan ini tak boleh meng-logout UI.
 */
export async function loadDisplayedBrandRules(
  customerId: string,
  groupId: string,
  fetchRules: () => Promise<GroupBrandRule[]>
): Promise<GroupBrandRule[] | null> {
  try {
    const rules = await fetchRules();
    rememberSessionBrandRules(customerId, rules, groupId);
    return rules;
  } catch (err) {
    const previous =
      session && session.customerId === customerId && session.groupId === groupId
        ? [...session.rules]
        : null;
    console.warn(
      previous
        ? "[harga-khusus:fetch-failed] aturan diskon merek level tak termuat — memakai aturan sebelumnya"
        : "[harga-khusus:fetch-failed] aturan diskon merek level tak termuat",
      err
    );
    return previous;
  }
}
